import { LOCALE } from 'src/dataLayer/env'
import { reportAPIFailure } from 'src/dataLayer/remoteData/rollbar'

import awsApiClient from './awsApiClient'

const authenticate = () => awsApiClient.authenticate(LOCALE)

const catchApiClientFetch = async (requiresAuthentication, verb, payload) => {
  try {
    if (requiresAuthentication) {
      await authenticate()
    }
    return await awsApiClient.fetch({ verb, ...payload })
  } catch (error) {
    reportAPIFailure(error, payload)
  }
}

const authenticatedGet = (payload) => catchApiClientFetch(true, 'GET', payload)

export { authenticate, authenticatedGet }
